export const supportLink = {
    inquiryText: '解決しない場合や機能に関するご質問・リクエストは下記より受け付けております。',
    inquiry: '問い合わせ',
    otherPages: 'ぜひこちらもご活用ください。'
}
